<form [formGroup]="form">
    <div class="flex justify-between items-center w-full pr-2 mb-2">
        <label #subtitleLabel for="location" class="text-label">{{ label }}</label>

        @if (showBlocker) {
            <app-lock-toggle
                [unlocked]="enabled"
                (pressed)="toggleEnabled()"
            ></app-lock-toggle>
        }
    </div>

    <div
        #inbox
        class="w-full h-10 flex justify-center items-center px-2 py-1 rounded-sm shadow-lg border bg-white"
        [class.border-blue-700]="enabled"
        [class.border-gray-300]="!enabled"
    >
        <input
            type="text"
            class="w-full h-full border-none outline-none focus:ring-0 rounded px-3 py-2 placeholder:text-gray-500"
            [class.bg-gray-100]="!enabled"
            #location
            autocomplete="off"
            id="location"
            formControlName="location"
            aria-describedby="locationHelp"
            placeholder="Escribe tu ubicación"
            (blur)="validateBlur()"
            (keydown)="makeInvalid()"
            (input)="filterLocations($event)"
            (focus)="filterLocations($event)"
            (keydown.escape)="esc()">
    </div>

    <ul id="list" class="max-h-[300px] relative overflow-y-scroll mt-2 bg-white border border-gray-200">
        <div class="relative">
            @for (location of filteredLocations(); track $index) {
                <li class="list-group-item p-2 hover:bg-gray-100 cursor-pointer" (click)="selectLocation(location.id, location.name)">
                    {{ location.name }}
                </li>
            }
        </div>
    </ul>

    @if (hasError()) {
        <div class="text-red-500 text-[10px] mt-1">Por favor selecciona un elemento de la lista.</div>
    }
</form>
